<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">タググループ一覧</h2>
        <permission-guard situation="tag_management">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center" style="width: 50px">ID</th>
                  <th class="text-center">名前</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="tagGroup in tagGroups" :key="tagGroup.id">
                  <td class="text-center">
                    {{ tagGroup.id }}
                  </td>
                  <td class="text-center">
                    {{ tagGroup.groupName }}
                  </td>
                  <td class="text-center">
                    <router-link
                      :to="{
                        name: 'adminTagGroupEdit',
                        params: { tag_group_id: tagGroup.id },
                      }"
                    >
                      <v-btn tile outlined small color="primary">
                        <v-icon left small> mdi-pencil</v-icon>
                        EDIT
                      </v-btn>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: { PermissionGuard },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'タググループ一覧',
      page: 1,
      tagGroups: []
    }
  },
  mounted: function () {
    axios.get('/api/tag_groups').then(
      ({ data }) => {
        data.forEach((d) => this.tagGroups.push(d.attributes))
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.messages
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  }
}
</script>
<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
